// @ts-nocheck
// Adapted from tailuge/billiards (GPL-3.0) — src/view/ballmaterialfactory.ts
// 番号テクスチャを球面へ投影する PBR マテリアル。Session 依存を除去。
// 反射/クリアコートを抑えて色のコントラストを確保（washout 防止）。
import { Color, MeshPhysicalMaterial } from "three"
import { R } from "../../engine/constants"
import { BallTextureFactory } from "./balltexturefactory"

const cache: Map<string, MeshPhysicalMaterial> = new Map()

function buildProjected(texture, color: Color): MeshPhysicalMaterial {
  const material = new MeshPhysicalMaterial({
    color: color,
    roughness: 0.16,
    metalness: 0,
    clearcoat: 0.4,
    clearcoatRoughness: 0.06,
    reflectivity: 0.18,
    envMapIntensity: 0.28, // 環境反射の白被りを抑えて素の色を立たせる
  })

  material.onBeforeCompile = (shader: any) => {
    shader.uniforms.numberTex = { value: texture }
    shader.uniforms.invScale = { value: 1 / (R * 2) }

    shader.vertexShader = shader.vertexShader.replace(
      "#include <common>",
      `#include <common>
       varying vec3 vLocalPosition;`,
    )
    shader.vertexShader = shader.vertexShader.replace(
      "#include <begin_vertex>",
      `#include <begin_vertex>
       vLocalPosition = position;`,
    )

    shader.fragmentShader = shader.fragmentShader.replace(
      "#include <common>",
      `#include <common>
      uniform sampler2D numberTex;
      uniform float invScale;
      varying vec3 vLocalPosition;`,
    )
    shader.fragmentShader = shader.fragmentShader.replace(
      "#include <color_fragment>",
      `#include <color_fragment>
      vec2 projUv = vLocalPosition.xz * invScale + 0.5;
      vec2 dx = dFdx(projUv);
      vec2 dy = dFdy(projUv);
      if (vLocalPosition.y < 0.0) {
        projUv.x = 1.0 - projUv.x;
        dx.x = -dx.x;
        dy.x = -dy.x;
      }
      projUv = clamp(projUv, 0.0, 1.0);
      vec4 texColor = textureGrad(numberTex, projUv, dx * 0.5, dy * 0.5);
      // テクスチャは sRGB で作成 → 手動サンプルのためここでリニアへ変換（色の濃さを保つ）。
      diffuseColor.rgb = pow(texColor.rgb, vec3(2.2));`,
    )
  }
  return material
}

export function createProjectedMaterial(
  label: number,
  color: Color,
  size = 256,
): MeshPhysicalMaterial {
  const key = `projected_${label}_${color.getHex()}_${size}`
  const cached = cache.get(key)
  if (cached) return cached
  const texture = BallTextureFactory.getOrCreateTexture(label, color, size)
  const material = buildProjected(texture, color)
  cache.set(key, material)
  return material
}

/** マーク付き練習用手球マテリアル（白地・赤ドット）。 */
export function createCueMaterial(size = 256): MeshPhysicalMaterial {
  const key = `cue_practice_${size}`
  const cached = cache.get(key)
  if (cached) return cached
  const texture = BallTextureFactory.getOrCreateCueTexture(size)
  const material = buildProjected(texture, new Color(0xffffff))
  cache.set(key, material)
  return material
}
